import React from 'react'
import '../SHop/shop.css';
function ShopHeader() {
  return (
    <div className="shop-header heading">
      <div >
        <h2>#stayhome</h2>
        <p>Save more with cupouns & up tp 70% off</p>
      </div>
    </div>
  );
}

export default ShopHeader